import React from 'react';
import { Link } from 'react-router-dom';
import { injectIntl, intlShape } from "@edx/frontend-platform/i18n";
import messages from "./messages";

const RecommendationsRow = ({ intl, ...props }) => {
    const { title, children, seeAllLink } = props

    return (
        <div className="recommendations-row-container">
            <div className="recommendations-row__header">
                <div className="recommendations-row__title">{title}</div>
                {seeAllLink && <Link to={seeAllLink} className="recommendations-row__link">
                    {intl.formatMessage(messages.seeAll)}
                </Link>}
            </div>
            <div className="recommendations-row">
                {children}
            </div>
        </div>
    );
}

RecommendationsRow.propTypes = {
    intl: intlShape.isRequired,
};

export default injectIntl(RecommendationsRow);